<div class="approve-dialog">
    <div class="approve-dialog__inner">
    <div class="approve-dialog__icon-wrap">
        <div class="approve-dialog__icon-ring">
            <mat-icon class="approve-dialog__icon">task_alt</mat-icon>
        </div>
    </div>

    <h2 class="approve-dialog__title">{{ data.title }}</h2>
    <div class="approve-dialog__divider"></div>

    <div class="approve-dialog__actions">
        <button type="button" class="approve-dialog__btn approve-dialog__btn--secondary" mat-stroked-button
            (click)="closeDialog(false)">
            Cancel
        </button>
        <button type="button" class="approve-dialog__btn approve-dialog__btn--primary" mat-raised-button
            (click)="closeDialog(true)" cdkFocusInitial>
            {{ data.buttonName ? data.buttonName : 'Submit' }}
        </button>
    </div>
    </div>
</div>